import { locale } from 'element-ui'
import elementLocales from './element-locales'
import locales from '../../lang/index'
import mixin from './mixin'
import { remove } from '../../utils/array'

let langs = {}
const componentsCollection = []
let _Vue

const update = () => {
  let len = componentsCollection.length
  while (len--) {
    componentsCollection[len] && componentsCollection[len].$forceUpdate()
  }
}
const mergeLangs = data => {
  if (data && typeof data === 'object') {
    const merged = {}
    for (const [key, lang] of Object.entries(data)) {
      merged[key] = {
        ...locales[key],
        ...lang
      }
    }
    langs = merged
  }
}

export let currentLocale = localStorage.getItem('sp-locale') || Object.keys(langs)[0]

export const format = (str = '', params = []) => {
  let index = 0
  return str.replace(/%s/g, () => index >= params.length ? '%s' : params[index++])
}

export let i18n = (key, params = []) => {
  // no json file
  if (langs === {}) {
    return key
  }
  // assume the first lang is the default lang
  const defaultLangKey = Object.keys(langs)[0]
  const langKey = localStorage.getItem('sp-locale') || defaultLangKey
  // missing json file
  if (!langs[langKey] || !langs[defaultLangKey]) {
    return key
  }
  const defaultLangText = langs[defaultLangKey][key] || key
  const langText = langs[langKey][key] || defaultLangText
  return format(langText, params)
}

export const setI18nData = data => {
  mergeLangs(data)
  update()
}

export const setLocale = l => {
  currentLocale = l
  localStorage.setItem('sp-locale', l)
  locale(elementLocales[l])
  const [title, suffix] = document.title.split(' - ')
  document.title = suffix || title

  update()
}

export const subscribeDataChanging = vm => componentsCollection.push(vm)
export const unsubscribeDataChanging = vm => remove(componentsCollection, vm)

export const install = (Vue, opts = {}) => {
  if (install.installed) {
    console.warn('already installed.')
    return
  }
  if (opts.i18n) {
    i18n = opts.i18n
    return
  }

  _Vue = Vue
  install.installed = true
  Vue.mixin(mixin)

  mergeLangs(opts.locale)
  Vue.prototype.$i18n = i18n
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default { install }



// WEBPACK FOOTER //
// ./packages/helper/i18n/index.js